module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/4-9f6852b21b9d67c1de4fe5725da4daf6.webp";